import { IconFactory } from '@assets';

export const extractBatchStatusByIcon = (icon: any): string => {
  const iconToStatusMap = new Map([
    [IconFactory.anomaliesHandled, 'All anomalies handled with proposal'],
    [IconFactory.failed, 'Invalid file'],
    [IconFactory.customsProcessing, 'Validation in progress (waiting for customer answer)'],
    [IconFactory.released, 'Declarations released'],
    [IconFactory.anomaliesHSCodeOrDescription, 'Anomalie(s) detected: HS codes and/or description'],
    [IconFactory.noSentAnomalies, 'No anomalies detected'],
    [IconFactory.rejected, 'Declarations rejected'],
    [IconFactory.anomalyValue, 'Anomalie(s) detected: value'],
    [IconFactory.notSent, 'Not sent'],
    [IconFactory.customsSync, 'Customs sync'],
    [IconFactory.notReleased, 'Declarations not-released'],
    [IconFactory.invalidated, 'Declarations invalidated'],
    [IconFactory.processing, 'Validation in progress (waiting for customs answer)'],
  ]);

  return iconToStatusMap.get(icon) || 'Unknown status';
};
